import VueRouter from 'vue-router'
import BidNumber from '@/utilities/core/validation/BidNumber'

export default class RouteQuery {
  static bidNumber(router: VueRouter): string | null {
    const capturingBidNumber = /(?<bid>ID-\d{4}-\d{4})/
    const bidNumber = router.currentRoute.path.match(capturingBidNumber)?.groups?.bid ?? ''
    return BidNumber.isValid(bidNumber) ? bidNumber : null
  }
}
